export const menuItems = [
    {
        id: 1,
        perm: "view_dashboard",
        label: "Dashboard",
        icon: "bx-home-circle",
        link: "/dashboard"
    },
    {
        id: 8,
        isLayout: true
    },
    {
        id: 3,
        perm: "new_sale",
        label: "menuitems.order.text",
        icon: "bx-cart",
        link: "/sales/order"
    },
    {
        id: 7,
        perm: "agentsale",
        label: "Agent sale",
        icon: "bx-cart",
        link: "/sales/agentsale"
    },
    {
        id: 12,
        perm: "stock_tab",
        label: "menuitems.stock.text",
        icon: "bx-store",
        subItems: [{
                id: 13,
                perm: "view_shop_stock",
                label: "menuitems.stock.list.level",
                link: "/stock/view",
                parentId: 12
            },
            {
                id: 14,
                perm: "add_shop_stock",
                label: "menuitems.stock.list.addstock",
                link: "/purchase/new",
                parentId: 12
            },
            {
                id: 15,
                perm: "view_spoilt_stock",
                label: "menuitems.stock.list.spoilt",
                link: "/stock/spoilt",
                parentId: 12
            },
            {
                id: 16,
                perm: "view_short_expiries",
                label: "menuitems.stock.list.expiries",
                link: "/stock/shortExpiries",
                parentId: 12
            },
            {
                id: 17,
                perm: "reconcile_shop_stock",
                label: "menuitems.stock.list.reconcile",
                link: "/stock/reconcile",
                parentId: 12
            },
            {
                id: 18,
                perm: "transfer_stock",
                label: "menuitems.stock.list.transfer",
                link: "/stock/transfer",
                parentId: 12
            },
            {
                id: 19,
                perm: "view_reconciliation_report",
                label: "menuitems.stock.list.report",
                link: "/reconciliation/report",
                parentId: 12
            },
            {
                id: 20,
                perm: "view_expired_stock",
                label: "menuitems.stock.list.expired",
                link: "/stock/expired",
                parentId: 12
            },
            {
                id: 21,
                perm: "transfer_stock",
                label: "Internal Stock Transfer",
                link: "/stock/intransfer",
                parentId: 12
            },
            {
                id: 121,
                perm: "transfer_stock",
                label: "Direct Stock Transfer",
                link: "/stock/transfer/direct",
                parentId: 12
            },
            
            {
            id: 119,
            perm: "view_reconciliation_report",
            label: "Reconciliation Summary Report",
            link: "/reconciliation/summary",
            parentId: 12
            },
        ]
    },
    {
        id: 62,
        perm: "agentstock_tab",
        label: "Agents Stock",
        icon: "bx-store",
        subItems: [{
                id: 63,
                perm: "view_agentstock",
                label: "Stock",
                link: "/agent_stock/stock",
                parentId: 62
            },
            {
                id: 64,
                perm: "view_agentstock",
                label: "Agent stock value",
                link: "/agent_stock/stockvalue",
                parentId: 62
            },
            {
                id: 65,
                perm: "record_disbursements",
                label: "Disburse",
                link: "/agent_stock/disburse",
                parentId: 62
            },
            {
                id: 66,
                perm: "manage_disbursements",
                label: "Disbursements",
                link: "/agent_stock/disbursements",
                parentId: 62
            },
            {
                id: 67,
                perm: "reconcile_agentstock",
                label: "Reconcile agent stock",
                link: "/agent_stock/reconcile_stock",
                parentId: 62
            },
            {
                id: 68,
                perm: "view_agentstock_reconcilation",
                label: "menuitems.stock.list.report",
                link: "/agent_stock/reconcilation_report",
                parentId: 62
            },
            {
                id: 69,
                perm: "manage_agent_damages",
                label: "Damages",
                link: "/agent_stock/damages",
                parentId: 62
            },
            {
                id: 70,
                perm: "manage_agentstock_returns",
                label: "Return Stock",
                link: "/agent_stock/return_stock",
                parentId: 62
            },
            {
                id: 71,
                perm: "view_agentstock_returns",
                label: "Agent stock returns",
                link: "/agent_stock/stock_returns",
                parentId: 62
            },

        ]
    },
    {
        id: 51,
        perm: "agentsale",
        label: "Missed Customers",
        icon: "bx-user",
        link: "/missed_customers"
    },
    {
        id: 53,
        perm: "store_tab",
        label: "menuitems.store.text",
        icon: "bx-store",
        subItems: [{
                id: 54,
                perm: "view_store_stock",
                label: "menuitems.store.list.level",
                link: "/store/view",
                parentId: 53
            },
            {
                id: 55,
                perm: "add_store_stock",
                label: "menuitems.store.list.addstock",
                link: "/store/add",
                parentId: 53
            },
            
            {
                id: 56,
                perm: "reconcile_store_stock",
                label: "menuitems.store.list.reconcile",
                link: "/store/reconcile",
                parentId: 53
            },

            {
                id: 57,
                perm: "view_purchases_report",
                label: "menuitems.store.list.purchaseReport",
                link: "/store/purchases",
                parentId: 53
            },
        ]
    },
    {
        id: 29,
        perm: "products_tab",
        label: "menuitems.products.text",
        icon: "bx-grid",
        subItems: [
            {
                id: 3030,
                perm: "add_products",
                label: "Add products",
                link: "/products/add",
                parentId: 29
            },
            {
                id: 30,
                perm: "view_products",
                label: "menuitems.products.list.view",
                link: "/products/view",
                parentId: 29
            },
            {
                id: 31,
                perm: "view_product_categories",
                label: "menuitems.products.list.categories",
                link: "/categories/view",
                parentId: 29
            },
            {
                id: 32,
                perm: "view_business_products",
                label: "menuitems.products.list.business",
                parentId: 29,
                link: "/business/products",
            },
            {
                id: 33,
                perm: "view_units",
                label: "menuitems.products.list.units",
                parentId: 29,
                link: "/units/view",
            },
            {
                id: 34,
                perm: "view_product_units",
                label: "menuitems.products.list.punits",
                parentId: 29,
                link: "/products/units",
            },
            {
                id: 35,
                perm: "view_services",
                label: "menuitems.products.list.services",
                parentId: 29,
                link: "/services/view",
            }
        ]
    },
    // {
    //     id: 36,
    //     perm: "consumables_tab",
    //     label: "Consumables",
    //     icon: "bx-grid",
    //     subItems: [{
    //             id: 6,
    //             perm: "stocking_report",
    //             label: "Current Stock",
    //             link: "/consumables/currentstock",
    //             parentId: 36
    //         },
    //         {
    //             id: 37,
    //             perm: "add_consumable_items",
    //             label: "Add Items",
    //             link: "/consumables/add_item",
    //             parentId: 36
    //         },
    //         {
    //             id: 38,
    //             perm: "stocking_consumables",
    //             label: "Add to Stock",
    //             link: "/consumables/stocking",
    //             parentId: 36
    //         },
    //         {
    //             id: 39,
    //             perm: "using_consumables",
    //             label: "Usage",
    //             parentId: 36,
    //             link: "/consumables/usage",
    //         },
    //         {
    //             id: 40,
    //             perm: "stocking_report",
    //             label: "Stocking Report",
    //             parentId: 36,
    //             link: "/consumables/stocking_report",
    //         },
    //         {
    //             id: 40,
    //             perm: "usage_report",
    //             label: "Usage Report",
    //             parentId: 36,
    //             link: "/consumables/usage_report",
    //         },
    //     ]
    // },
    {
    id: 36,
    perm: "consumables_tab",
    label: "Consumables",
    icon: "bx-grid",
    subItems: [        
        {
            id: 9,
            label: "Items",
            subItems: [                
                {
                    id: 6,
                    perm: "stocking_report",
                    label: "Current Stock",
                    link: "/consumables/currentstock",
                    parentId: 9
                },
                {
                    id: 11,
                    perm: "add_consumable_items",
                    actionpage: "1",
                    label: "Add Item Units",
                    link: "/consumables/item_units",
                    parentId: 9
                },
                {
                    id: 361,
                    perm: "add_consumable_items",
                    actionpage: "1",
                    label: "Add Items",
                    link: "/consumables/add_item",
                    parentId: 9
                },
            ],
            parentId: 36
        },
        {
            id: 8,
            perm: "stocking_consumables",
            label: "Stock",
            subItems: [
                {
                    id: 38,
                    perm: "stocking_consumables",
                    actionpage: "1",
                    label: "Add to Stock",
                    link: "/consumables/stocking",
                    parentId: 8
                },
                {
                    id: 39,
                    perm: "using_consumables",
                    actionpage: "1",
                    label: "Usage",
                    parentId: 8,
                    link: "/consumables/usage",
                },
                {
                    id: 58,
                    perm: "reconcile_consumables_stock",
                    actionpage: "1",
                    label: "menuitems.stock.list.reconcile",
                    link: "/consumables/reconcile",
                    parentId: 8
                },
                {
                    id: 59,
                    perm: "view_spoilt_consumables",
                    label: "menuitems.stock.list.spoilt",
                    link: "/consumables/spoilt",
                    parentId: 8
                },
            ],
            parentId: 36
        },
        {
            id: 10,
            label: "Production",
            subItems:[
                {
                    id: 140,
                    perm: "add_shop_stock",
                    actionpage: "1",
                    label: "Make Order",
                    parentId: 10,
                    link: "/consumables/make_order",
                },
                {
                    id: 40,
                    perm: "set_ingredients",
                    actionpage: "1",
                    label: "Set Ingredients",
                    parentId: 10,
                    link: "/consumables/setingredients",
                },
                {
                    id: 44,
                    perm: "set_ingredients",
                    actionpage: "1",
                    label: "View Ingredients",
                    parentId: 10,
                    link: "/consumables/ingredients",
                },
                {
                    id: 45,
                    perm: "record_output",
                    actionpage: "1",
                    label: "Output",
                    parentId: 10,
                    link: "/consumables/output",
                }, 
            ],
            parentId: 36,            
        },
        {
            id: 159,
            perm: "stocking_report",
            label: "Purchases Report",
            link: "/consumables/purchases_report",
            parentId: 36
        },     
        {
            id: 41,
            perm: "stocking_report",
            label: "Stocking Report",
            parentId: 36,
            link: "/consumables/stocking_report",
        },
        {
            id: 42,
            perm: "usage_report",
            label: "Usage Report",
            parentId: 36,
            link: "/consumables/usage_report",
        },
        {
            id: 43,
            perm: "stocking_consumables",
            label: "Creditors report",
            parentId: 36,
            link: "/consumables/creditors",
        },
        {
            id: 144,
            perm: "view_shop_stock",
            label: "Production Orders",
            parentId: 36,
            link: "/consumables/production_orders",
        },
        {
            id: 145,
            perm: "view_transactions_report",
            label: "Manufacturing Report",
            parentId: 36,
            link: "/consumables/manufacturing_report",
        },
    ]
    },
    {
        id: 37,
        perm: "expenses_tab",
        label: "menuitems.expenses.text",
        icon: "bx-food-menu",
        subItems: [{
                id: 72,
                perm: "view_agentexpenses",
                label: "Agent Expenses",
                link: "/expenses/agentexpenses",
                parentId: 37
            },
            {
            id: 3712,
            perm: "add_expenses",
            actionpage: "1",
            label: "Record Expense",
            link: "/expenses/record_bulkexpenses",
            parentId: 37
            },
            {
            id: 372,
            perm: "view_expenses",
            label: "Creditors ",
            link: "/expenses/creditors",
            parentId: 37
            },
            {
                id: 39,
                perm: "view_expense_categories",
                label: "menuitems.expenses.list.categories",
                link: "/expenses/categories",
                parentId: 37
            },
            {
                id: 40,
                perm: "view_expenses_report",
                label: "menuitems.expenses.list.report",
                link: "/expenses/report",
                parentId: 37
            },
            {
            id: 376,
            perm: "view_expenses",
            label: "Expense Payments",
            link: "/expenses/expense_payments",
            parentId: 37
        },
        ]
    },
    {
        id: 46,
        perm: "reports_tab",
        label: "menuitems.reports.text",
        icon: "bxs-folder-open",
        subItems: [{
                id: 47,
                perm: "view_sales_report",
                label: "menuitems.reports.list.sreport",
                link: "/sales",
                parentId: 46
            },
            {
                id: 147,
                perm: "view_payments_report",
                label: "Payments Report",
                link: "/payments",
                parentId: 46
            },
            {
                id: 247,
                perm: "view_purchase_payments_report",
                label: "Purchase Payments",
                link: "/purchase_payments",
                parentId: 46
            },
            {
                id: 48,
                perm: "view_purchases_report",
                label: "menuitems.reports.list.preport",
                link: "/shop/purchases",
                parentId: 46
            },
            {
                id: 49,
                perm: "view_debtors_report",
                label: "menuitems.reports.list.debtor",
                link: "/sales/debtors",
                parentId: 46
            },
            {
                id: 50,
                perm: "view_creditors_report",
                label: "menuitems.reports.list.creditor",
                link: "/purchases/creditors",
                parentId: 46
            },
            {
                id: 150,
                perm: "view_stock_transfers",
                label: "menuitems.stock.list.transfers",
                link: "/stock/transfers",
                parentId: 46
            },
            {
                id: 54,
                perm: "view_held_sales",
                label: "menuitems.reports.list.held",
                link: "/sales/held",
                parentId: 46
            },
            {
                id: 547,
                perm: "view_sales_report",
                label: "Discounts Allowed",
                link: "/sales/discounts",
                parentId: 46
            },
        ]
    },
    {
        id: 52,
        perm: "view_messages",
        label: "menuitems.message.text",
        icon: "bx-paper-plane",
        link: "/messages"
    },

];